<script setup lang="ts">
import { computed } from 'vue'
import { decodeHtmlEntities, stripHtmlTags } from '../../utils/utils'
import { VocabItem } from '../../types/session';


const props = defineProps<{
    vocab: VocabItem
}>()

function escapeRegExp(input: string): string {
    return input.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

const regex = computed<RegExp | null>(() => {
    const q = props.vocab.word
    if (!q || !q.trim()) return null
    const core = escapeRegExp(q.trim())
    return new RegExp(`(?<![\p{L}\p{N}_])(${core})(?![\p{L}\p{N}_])`, 'giu')
})

const highlightedHtml = computed<string>(() => {
    let text = decodeHtmlEntities(props.vocab.contentExample ?? '')
    text = stripHtmlTags(text)

    const re = regex.value
    if (!re) return text.replace(/\n/g, '<br>')

    let lastIndex = 0
    const parts: string[] = []

    for (const m of text.matchAll(re)) {
        const start = m.index ?? 0
        const end = start + (m[0]?.length ?? 0)
        if (end <= lastIndex) continue

        parts.push(text.slice(lastIndex, start))
        const matched = text.slice(start, end)
        parts.push(`<span class=\"text-yellow-500 font-semibold\">${matched}</span>`)
        lastIndex = end
    }
    parts.push(text.slice(lastIndex))

    return parts.join('').replace(/\n/g, '<br>')
})
</script>
<template>
    <div class="lg:text-lg font-bold" v-html="highlightedHtml"></div>
</template>